import { type FactoryProvider } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorI18n } from './paginator-i18';

export function provideMatPaginatorIntl(): FactoryProvider {
  return {
    provide: MatPaginatorIntl,
    useFactory: () => new PaginatorI18n().getPaginatorIntl(),
  };
}
